import Model from 'flarum/common/Model';

export default class QuizQuestion extends Model {}

Object.assign(QuizQuestion.prototype, {
  articleId: Model.attribute('article_id'),
  questionType: Model.attribute('question_type'),
  question: Model.attribute('question'),
  options: Model.attribute('options'),
  correctAnswer: Model.attribute('correct_answer'),
  sortOrder: Model.attribute('sort_order'),
  createdAt: Model.attribute('created_at', Model.transformDate),
  updatedAt: Model.attribute('updated_at', Model.transformDate),
});
